import axios from 'axios'

export const StripeApiClient = axios.create()
